import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const MessageButton = ({ hostessId, className = "", testid }) => {
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const open = async () => {
    setLoading(true);
    try {
      const r = await api.post("/conversations", { hostess_id: hostessId });
      nav(`/messaggi/${r.data.id}`);
    } catch (e) { toast.error(formatApiError(e)); setLoading(false); }
  };
  return (
    <button onClick={open} disabled={loading} className={className} data-testid={testid}>
      <MessageCircle className="w-3.5 h-3.5" /> {loading ? "Apertura…" : "Scrivi un messaggio"}
    </button>
  );
};
